import { useParams } from 'react-router-dom';
import I18n from 'I18n';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { utcToRolloutOffsetLocal } from '../../app/utils/dateUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RolloutProductUpdatesScheduledForReleaseTag({
  rolloutState,
  date
}) {
  const {
    category
  } = useParams();
  if (rolloutState === 'LIVE' || rolloutState === 'SUNSET' || !date) {
    return null;
  }
  const releaseDateMoment = utcToRolloutOffsetLocal(date);
  const now = utcToRolloutOffsetLocal(I18n.moment());
  if (releaseDateMoment.isBefore(now) && category !== 'scheduled-for-release' && rolloutState !== 'UPCOMING_SUNSET') {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(StatusTag, {
      use: "success",
      hollow: true,
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "app.statusTags.scheduledForReleasePrefix_jsx",
        elements: {
          FormattedDateTime
        },
        options: {
          type: 'userTz',
          value: releaseDateMoment,
          format: 'LL'
        }
      })
    })
  });
}